var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white px-3",staticStyle:{"margin-left":"-20px","margin-top":"-1rem","margin-bottom":"0!important"}})}
var staticRenderFns = []

export { render, staticRenderFns }